// Service Areas — Counties & Cities India serves in-person.
// Each county also has a `neighborhoods` array of additional smaller towns/communities
// rendered as display-only pills on the county page (no individual landing page).

// Major hospital networks India regularly visits for bedside, hospice, and senior-living notarizations.
// Surfaced on the AreasWeServePage so referral coordinators and case managers can confirm coverage at a glance.
export const HOSPITAL_NETWORKS = [
  {
    slug: 'ascension-saint-thomas',
    name: 'Ascension Saint Thomas',
    blurb: "India regularly visits every Ascension Saint Thomas location across Middle Tennessee — bedside notarizations, healthcare directives, POAs, and estate signings handled with hospital-grade discretion.",
    locations: [
      'Saint Thomas Midtown · Nashville',
      'Saint Thomas West · Nashville',
      'Saint Thomas Rutherford · Murfreesboro',
      'Saint Thomas Hickman · Centerville',
      'Saint Thomas Stones River · Woodbury',
      'Saint Thomas DeKalb · Smithville',
      'Saint Thomas Highlands · Sparta',
      'Saint Thomas River Park · McMinnville',
      'All other Ascension Saint Thomas locations across Tennessee',
    ],
  },
  {
    slug: 'tristar-health',
    name: 'TriStar Health',
    blurb: "India routinely covers the three flagship TriStar hospitals serving Davidson, Williamson, and Sumner counties — bedside signings scheduled the same day in most cases.",
    locations: [
      'TriStar Centennial Medical Center · Nashville',
      'TriStar Skyline Medical Center · Nashville',
      'TriStar Southern Hills Medical Center · Nashville',
    ],
  },
  {
    slug: 'vanderbilt-health',
    name: 'Vanderbilt University Medical Center',
    blurb: "India is a familiar bedside notary across Vanderbilt's Nashville campus and regional locations — known for quick response on time-sensitive estate and healthcare-directive signings.",
    locations: [
      'Vanderbilt University Hospital · Nashville',
      'Monroe Carell Jr. Children\'s Hospital at Vanderbilt · Nashville',
      'Vanderbilt Wilson County Hospital · Lebanon',
      'Vanderbilt Tullahoma–Harton Hospital · Tullahoma',
      'Vanderbilt Bedford Hospital · Shelbyville',
      'All Vanderbilt Health regional clinics & outpatient locations',
    ],
  },
];

export const COUNTIES = [
  {
    slug: 'davidson-county',
    name: 'Davidson County',
    seat: 'Nashville',
    population: '720,000+',
    cityCount: 12,
    cities: ['nashville', 'belle-meade', 'goodlettsville', 'antioch', 'hermitage'],
    neighborhoods: [
      'East Nashville', 'Green Hills', 'Bellevue', 'Donelson', 'Madison', 'Inglewood',
      'The Gulch', 'Germantown', '12 South', 'Sylvan Park', 'Berry Hill', 'Forest Hills',
      'Oak Hill', 'Whites Creek', 'Joelton',
    ],
    landmarks: 'Music Row, Vanderbilt University Medical Center, Saint Thomas Hospitals, BNA International Airport, Bridgestone Arena, Music City Center',
    courthouses: 'Metro Davidson County Courthouse · General Sessions Court · Probate Court',
    intro:
      "Davidson County is home base. As Nashville's resident MBA-led mobile notary, India regularly travels to attorneys' offices in The Gulch, hospital bedsides at Vanderbilt and Saint Thomas, downtown high-rises, and family kitchen tables in East Nashville, Green Hills, and Bellevue. If your document needs to be notarized in Davidson County, India can usually be at your door within the hour.",
    bullets: [
      'Bedside hospital signings at Vanderbilt, Saint Thomas Midtown/West, TriStar Centennial, and Nashville General',
      'Loan signings for Nashville-area title companies (Davidson County deeds and HELOCs daily)',
      'Apostille handling with same-week turnaround through the Tennessee Secretary of State',
      'Estate planning packages — trusts, healthcare directives, and POAs notarized in your home',
      'Wedding officiant ceremonies at the Davidson County Courthouse and venues across Nashville',
    ],
    heroImage: 'https://images.pexels.com/photos/28412270/pexels-photo-28412270.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'williamson-county',
    name: 'Williamson County',
    seat: 'Franklin',
    population: '250,000+',
    cityCount: 8,
    cities: ['franklin', 'brentwood', 'spring-hill', 'nolensville', 'thompson-station'],
    neighborhoods: [
      'Cool Springs', 'Westhaven', 'Leiper\'s Fork', 'Fairview', 'Triune', 'College Grove',
      'Arrington', 'Berry Farms', 'McKay\'s Mill', 'Fieldstone Farms',
    ],
    landmarks: 'Cool Springs business district, Williamson Medical Center, Carnton Plantation, Leiper\'s Fork, The Factory at Franklin',
    courthouses: 'Williamson County Judicial Center · 21st Judicial District Chancery Court',
    intro:
      "Williamson County — home to Franklin, Brentwood, and Spring Hill — is one of India's most-traveled service areas. Cool Springs corporate executives needing apostilles before international flights, Brentwood families putting estate plans together, and Franklin attorneys closing loan packages all rely on India for accurate, on-time mobile notary service. She knows every back road from Hillsboro Pike to Highway 96 and is happy to meet at your home, office, or the closest Starbucks.",
    bullets: [
      'Cool Springs corporate apostilles & I-9 verifications for Williamson County employers',
      'Loan signings for Franklin and Brentwood title companies — title-company-approved NSA',
      'Estate signings at Williamson Medical Center and Brookdale senior-living communities',
      'Wedding officiant ceremonies in Franklin\'s historic district and Leiper\'s Fork venues',
      'Same-day general notary service across all of Williamson County',
    ],
    heroImage: 'https://images.pexels.com/photos/2898211/pexels-photo-2898211.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'sumner-county',
    name: 'Sumner County',
    seat: 'Gallatin',
    population: '200,000+',
    cityCount: 7,
    cities: ['hendersonville', 'gallatin', 'portland', 'white-house'],
    neighborhoods: [
      'Westmoreland', 'Cottontown', 'Bethpage', 'Mitchellville', 'Castalian Springs',
      'Indian Lake', 'Old Hickory Village', 'Fairvue Plantation',
    ],
    landmarks: 'Old Hickory Lake, Sumner Regional Medical Center, Volunteer State Community College, Bledsoe Creek State Park',
    courthouses: 'Sumner County Justice Center · Sumner County Chancery Court (Gallatin)',
    intro:
      "Sumner County families — Hendersonville, Gallatin, Goodlettsville, Portland, and Westmoreland — get the same Nashville-grade mobile notary service India brings to downtown clients. Whether it's a lakeside home in Hendersonville needing a refinance package signed, a Gallatin attorney drafting a trust, or a hospice visit at Sumner Regional Medical Center, India makes the drive happily.",
    bullets: [
      'Loan signings throughout Hendersonville, Gallatin, and Old Hickory Lake communities',
      'Bedside notary visits at Sumner Regional Medical Center and TriStar Hendersonville',
      'Estate planning home visits — trusts, healthcare directives, and POAs',
      'Mobile fingerprinting for Sumner County licensing and adoption filings',
      'Apostille handling with delivery anywhere in the county',
    ],
    heroImage: 'https://images.pexels.com/photos/4689068/pexels-photo-4689068.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'rutherford-county',
    name: 'Rutherford County',
    seat: 'Murfreesboro',
    population: '345,000+',
    cityCount: 6,
    cities: ['murfreesboro', 'smyrna', 'la-vergne', 'eagleville'],
    neighborhoods: [
      'Christiana', 'Rockvale', 'Lascassas', 'Walter Hill', 'Blackman', 'Stones River',
      'The Avenue Murfreesboro', 'Gateway',
    ],
    landmarks: 'Middle Tennessee State University (MTSU), Stones River National Battlefield, Saint Thomas Rutherford Hospital, Nissan Smyrna plant',
    courthouses: 'Rutherford County Judicial Building · Rutherford County Chancery Court (Murfreesboro)',
    intro:
      "Rutherford County is one of the fastest-growing counties in Tennessee — and India serves it like she's been there for decades. From MTSU faculty needing apostilles for international research postings, to Smyrna families closing on a new home, to attorneys filing estate documents in the Murfreesboro Judicial Building, India delivers the same accuracy and 24/7 availability she brings to downtown Nashville.",
    bullets: [
      'Loan signings throughout Murfreesboro, Smyrna, La Vergne, and Eagleville',
      'Hospital and senior-living visits at Saint Thomas Rutherford and NHC HealthCare',
      'MTSU faculty & student apostilles for international study, work, and adoption',
      'Estate planning packages signed at home or in your attorney\'s Murfreesboro office',
      'Wedding officiant for Rutherford County couples — courthouse and venue ceremonies',
    ],
    heroImage: 'https://images.pexels.com/photos/2833713/pexels-photo-2833713.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'wilson-county',
    name: 'Wilson County',
    seat: 'Lebanon',
    population: '160,000+',
    cityCount: 5,
    cities: ['mt-juliet', 'lebanon', 'watertown'],
    neighborhoods: [
      'Statesville', 'Norene', 'Gladeville', 'Tucker\'s Crossroads', 'Providence',
      'Five Oaks', 'Spence Creek', 'Riverwood',
    ],
    landmarks: 'Cedars of Lebanon State Park, Cumberland University, Providence Marketplace, Old Hickory Lake (north shore)',
    courthouses: 'Wilson County Courthouse · Wilson County Chancery Court (Lebanon)',
    intro:
      "Wilson County — Mt. Juliet, Lebanon, and Watertown — is a quick drive east of Nashville, and India makes it regularly. Whether you're a Mt. Juliet family closing on a Providence home, a Lebanon attorney filing a probate petition, or a Cumberland University staffer needing an I-9 done at your office, India is one call away.",
    bullets: [
      'Loan signings throughout Mt. Juliet, Lebanon, Watertown, and the Providence corridor',
      'Estate planning home visits in Mt. Juliet, Lebanon, and surrounding rural Wilson County',
      'Mobile notary for Cumberland University and Wilson County employers',
      'Hospital and senior-living visits across Lebanon and Mt. Juliet',
      'Apostille and international document service for Wilson County families',
    ],
    heroImage: 'https://images.pexels.com/photos/17715307/pexels-photo-17715307.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'maury-county',
    name: 'Maury County',
    seat: 'Columbia',
    population: '105,000+',
    cityCount: 5,
    cities: ['spring-hill', 'columbia', 'mount-pleasant'],
    neighborhoods: [
      'Culleoka', 'Hampshire', 'Williamsport', 'Santa Fe', 'Saturn Parkway',
      'Wales', 'Highway 99 corridor',
    ],
    landmarks: 'GM Spring Hill Manufacturing Plant, Maury Regional Medical Center, James K. Polk Home, downtown Columbia historic district',
    courthouses: 'Maury County Courthouse · Maury County Chancery Court (Columbia)',
    intro:
      "Maury County — Spring Hill, Columbia, and Mount Pleasant — is part of India's regular service rotation. Spring Hill's explosive growth means more refinance packages, more new-construction closings, and more young families putting estate plans in place. India handles every signing with the same precision she brings to her downtown Nashville clients.",
    bullets: [
      'Loan signings throughout Spring Hill, Columbia, and the GM-corridor neighborhoods',
      'Bedside visits at Maury Regional Medical Center and senior-living communities',
      'Apostille and document authentication for Maury County families and businesses',
      'Estate planning home visits — trusts, healthcare directives, and POAs',
      'Wedding officiant for Columbia\'s historic-district venues and Spring Hill couples',
    ],
    heroImage: 'https://images.pexels.com/photos/11467701/pexels-photo-11467701.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
];

// Helper to keep new city entries lean — generates standard bullets if not provided.
const stdBullets = (city) => [
  `Loan signings throughout ${city} and surrounding neighborhoods`,
  `Estate planning home visits — trusts, healthcare directives, and POAs in ${city}`,
  `Apostille and Tennessee Secretary of State filing for ${city} residents`,
  `Bedside notary visits at local hospitals and senior-living communities`,
  `General mobile notary — affidavits, vehicle titles, parental travel consent`,
];

export const CITIES = [
  {
    slug: 'nashville',
    name: 'Nashville',
    countySlug: 'davidson-county',
    countyName: 'Davidson County',
    zips: '37201, 37203, 37204, 37205, 37206, 37207, 37208, 37209, 37210, 37211, 37212, 37213, 37214, 37215, 37216, 37217, 37218, 37219, 37220, 37221',
    landmarks: 'Music Row, Lower Broadway, Vanderbilt Medical Center, Saint Thomas Hospitals, BNA Airport, The Gulch, East Nashville, Germantown',
    nearbyCities: ['brentwood', 'franklin', 'hendersonville', 'goodlettsville'],
    intro:
      "Nashville is home. As a Nashville-native MBA-led mobile notary, India crisscrosses Music City daily — Vanderbilt for bedside signings, downtown high-rises for executive apostilles, East Nashville bungalows for estate planning, and BNA-area hotels for traveling executives needing a quick notarization before a flight. If your document needs notarizing inside the 440 (or anywhere in Davidson County), India can usually be at your location within 60 minutes.",
    bullets: [
      'Same-hour bedside signings at Vanderbilt, Saint Thomas Midtown, TriStar Centennial, and Skyline Medical',
      'Downtown apostille pickup and Tennessee Secretary of State filing — often same-week',
      'Loan signings for Nashville title companies (Belle Meade, Green Hills, Bellevue, East Nashville closings daily)',
      'Estate planning home visits in every Nashville neighborhood — Sylvan Park to Donelson',
      'Wedding officiant for Davidson County Courthouse, downtown venues, and backyard ceremonies',
    ],
    heroImage: 'https://customer-assets.emergentagent.com/job_b8675834-c8ae-4883-bbc8-723ef71e34e7/artifacts/mj9l5ij8_iStock-1151607202-scaled.jpg',
  },
  {
    slug: 'belle-meade',
    name: 'Belle Meade',
    countySlug: 'davidson-county',
    countyName: 'Davidson County',
    zips: '37205',
    landmarks: 'Belle Meade Plantation, Belle Meade Country Club, Harpeth River, Percy Warner Park access',
    nearbyCities: ['nashville', 'brentwood', 'forest-hills'],
    intro:
      "Belle Meade clients expect discretion, polish, and absolute privacy — India delivers all three. From estate planning and trust signings in stately Harpeth Hills homes to apostilles for international travel, India\'s MBA background and corporate-grade poise make her the preferred mobile notary for Belle Meade families and the attorneys who serve them.",
    bullets: stdBullets('Belle Meade'),
    heroImage: 'https://images.pexels.com/photos/28412260/pexels-photo-28412260.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'goodlettsville',
    name: 'Goodlettsville',
    countySlug: 'davidson-county',
    countyName: 'Davidson County',
    zips: '37072',
    landmarks: 'Dollar General Corporate HQ, Rivergate Mall, Moss Wright Park, Long Hollow Pike corridor',
    nearbyCities: ['hendersonville', 'nashville', 'madison'],
    intro:
      "Goodlettsville — straddling Davidson and Sumner counties — is a regular stop on India\'s northbound route. Dollar General Corporate employees needing I-9 verifications, Rivergate-area families refinancing, and long-time Goodlettsville residents putting estate plans together all rely on India\'s prompt, on-time mobile notary service.",
    bullets: stdBullets('Goodlettsville'),
    heroImage: 'https://images.pexels.com/photos/11467701/pexels-photo-11467701.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'antioch',
    name: 'Antioch',
    countySlug: 'davidson-county',
    countyName: 'Davidson County',
    zips: '37011, 37013',
    landmarks: 'Hickory Hollow Mall area, Global Mall, Cane Ridge, Bell Road corridor, Mill Creek',
    nearbyCities: ['hermitage', 'la-vergne', 'nashville'],
    intro:
      "Antioch families and small-business owners get the same Nashville-downtown service India brings to The Gulch. From refinance closings off Bell Road to estate signings in Cane Ridge to bedside visits at TriStar Southern Hills, India serves Antioch with same-day availability and the polish her MBA background brings to every appointment.",
    bullets: stdBullets('Antioch'),
    heroImage: 'https://images.pexels.com/photos/2833713/pexels-photo-2833713.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'hermitage',
    name: 'Hermitage',
    countySlug: 'davidson-county',
    countyName: 'Davidson County',
    zips: '37076',
    landmarks: 'Andrew Jackson\'s Hermitage, Hermitage Hills, Old Hickory Lake (south shore), Lebanon Pike corridor',
    nearbyCities: ['mt-juliet', 'donelson', 'nashville'],
    intro:
      "Hermitage — anchored by Andrew Jackson\'s historic estate and growing residential subdivisions — keeps India busy with loan signings, estate planning visits, and apostille work. Whether you\'re closing on a Hermitage Hills home or finalizing a trust, India makes the easy drive from downtown.",
    bullets: stdBullets('Hermitage'),
    heroImage: 'https://images.pexels.com/photos/17715307/pexels-photo-17715307.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'franklin',
    name: 'Franklin',
    countySlug: 'williamson-county',
    countyName: 'Williamson County',
    zips: '37064, 37067, 37068, 37069',
    landmarks: 'The Factory at Franklin, Carnton Plantation, downtown Main Street historic district, Williamson Medical Center, Cool Springs',
    nearbyCities: ['brentwood', 'spring-hill', 'nashville'],
    intro:
      "Franklin's mix of historic Main Street charm and Cool Springs corporate energy means India handles a wide range of work here — small-business owners on 5th Avenue, Nissan and Mars executives in Cool Springs, Williamson Medical Center bedside signings, and Carnton-area families with estate plans. Whether you're at home off Hillsboro Pike or hosting a wedding at Carnton, India makes the trip happily.",
    bullets: [
      'Cool Springs corporate apostilles, I-9 verifications, and signing-agent support',
      'Loan signings for Franklin title companies — title-company-approved Notary Signing Agent',
      'Bedside visits at Williamson Medical Center and Brookdale Franklin',
      'Estate planning packages signed at your Franklin home or attorney\'s office',
      'Wedding officiant for Carnton, The Factory, downtown Franklin, and historic-district venues',
    ],
    heroImage: 'https://images.pexels.com/photos/6771336/pexels-photo-6771336.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'brentwood',
    name: 'Brentwood',
    countySlug: 'williamson-county',
    countyName: 'Williamson County',
    zips: '37024, 37027',
    landmarks: 'Maryland Farms business district, Brentwood Library, CoolSprings Galleria, Crockett Park, Concord Road corridor',
    nearbyCities: ['franklin', 'nashville', 'spring-hill'],
    intro:
      "Brentwood families and Maryland Farms executives are some of India's most loyal clients. From estate planning packages signed in stately Brentwood homes to corporate apostilles handled in Maryland Farms boardrooms, India brings the same MBA-grade precision she delivered in her Pulte Homes corporate-development days. Quiet, prompt, and dressed for the room.",
    bullets: [
      'Maryland Farms corporate apostilles and authorized-representative I-9 verifications',
      'Estate planning home visits — trusts, healthcare directives, POAs handled with discretion',
      'Loan signings for Brentwood title companies — same-day, error-free packages',
      'Bedside notary visits at Brookdale Brentwood and Concord-area senior-living communities',
      'Wedding officiant for Brentwood backyard ceremonies and Crockett Park celebrations',
    ],
    heroImage: 'https://images.pexels.com/photos/28412260/pexels-photo-28412260.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'nolensville',
    name: 'Nolensville',
    countySlug: 'williamson-county',
    countyName: 'Williamson County',
    zips: '37135',
    landmarks: 'Historic Nolensville Road, Mill Creek Greenway, Burkitt Place, downtown Nolensville',
    nearbyCities: ['brentwood', 'franklin', 'antioch'],
    intro:
      "Nolensville\'s rapid residential growth keeps India busy with new-construction closings, refinance packages, and first-time-homebuyer paperwork. The town\'s historic Main Street and family-friendly subdivisions also mean a steady stream of estate planning and wedding officiant requests.",
    bullets: stdBullets('Nolensville'),
    heroImage: 'https://images.pexels.com/photos/2898211/pexels-photo-2898211.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'thompson-station',
    name: 'Thompson\'s Station',
    countySlug: 'williamson-county',
    countyName: 'Williamson County',
    zips: '37179',
    landmarks: 'Thompson\'s Station Park, Tollgate Village, Heritage Common, Spring Station Middle School corridor',
    nearbyCities: ['franklin', 'spring-hill', 'nolensville'],
    intro:
      "Thompson\'s Station — wedged between Franklin and Spring Hill — is one of Williamson County\'s fastest-growing communities. India handles regular loan signings for Tollgate and Heritage Common closings, plus estate planning visits and apostilles for relocating families.",
    bullets: stdBullets('Thompson\'s Station'),
    heroImage: 'https://images.pexels.com/photos/4689068/pexels-photo-4689068.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'hendersonville',
    name: 'Hendersonville',
    countySlug: 'sumner-county',
    countyName: 'Sumner County',
    zips: '37075, 37077',
    landmarks: 'Old Hickory Lake, TriStar Hendersonville Medical Center, Streets of Indian Lake, Sanders Ferry Park',
    nearbyCities: ['gallatin', 'goodlettsville', 'nashville'],
    intro:
      "Hendersonville's lakeside neighborhoods, Streets of Indian Lake corporate offices, and family-owned businesses all keep India busy. Whether it's a refinance package on Old Hickory Boulevard, a bedside healthcare directive at TriStar Hendersonville, or an apostille for an Indian Lake-area family relocating overseas, India makes the 25-minute drive from downtown without complaint.",
    bullets: [
      'Loan signings throughout Hendersonville and the Old Hickory Lake corridor',
      'Bedside visits at TriStar Hendersonville Medical Center and area senior-living communities',
      'Estate planning home visits — trusts, healthcare directives, and POAs',
      'Apostille handling and Tennessee Secretary of State filing for Hendersonville families',
      'Wedding officiant for lakefront ceremonies and Sanders Ferry Park celebrations',
    ],
    heroImage: 'https://images.pexels.com/photos/2898211/pexels-photo-2898211.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'gallatin',
    name: 'Gallatin',
    countySlug: 'sumner-county',
    countyName: 'Sumner County',
    zips: '37066',
    landmarks: 'Sumner Regional Medical Center, Volunteer State Community College, Bledsoe Creek State Park, downtown Gallatin square',
    nearbyCities: ['hendersonville', 'goodlettsville', 'nashville'],
    intro:
      "Gallatin — the Sumner County seat — is a regular stop on India's weekly route. Whether it's a Sumner Regional bedside visit, a Volunteer State staff I-9 verification, a downtown-square attorney coordinating an estate filing, or a young family putting their first POA together, India brings the same Nashville-grade service to every Gallatin appointment.",
    bullets: [
      'Bedside notary visits at Sumner Regional Medical Center',
      'Loan signings throughout Gallatin and the surrounding Sumner County area',
      'Estate planning home visits — trusts, healthcare directives, POAs',
      'Apostille service for Gallatin families and Volunteer State faculty',
      'Wedding officiant for downtown Gallatin square and Bledsoe Creek venues',
    ],
    heroImage: 'https://images.pexels.com/photos/2833713/pexels-photo-2833713.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'portland',
    name: 'Portland',
    countySlug: 'sumner-county',
    countyName: 'Sumner County',
    zips: '37148',
    landmarks: 'Portland City Park, Strawberry Festival grounds, Highland Rim corridor, downtown Portland',
    nearbyCities: ['white-house', 'gallatin', 'hendersonville'],
    intro:
      "Portland — the friendly northernmost city in Sumner County — keeps India making regular drives up I-65. Loan signings, estate planning home visits, and the occasional Strawberry Festival-week wedding officiant request all bring her north.",
    bullets: stdBullets('Portland'),
    heroImage: 'https://images.pexels.com/photos/11467701/pexels-photo-11467701.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'white-house',
    name: 'White House',
    countySlug: 'sumner-county',
    countyName: 'Sumner County',
    zips: '37188',
    landmarks: 'Old Stagecoach Road, White House Heritage Park, Highway 31W corridor, White House Library',
    nearbyCities: ['portland', 'goodlettsville', 'hendersonville'],
    intro:
      "White House — straddling Sumner and Robertson counties — gets the same mobile notary service India brings to downtown Nashville. New-construction loan signings, refinances, estate plans, and apostilles all part of the regular White House calendar.",
    bullets: stdBullets('White House'),
    heroImage: 'https://images.pexels.com/photos/17715307/pexels-photo-17715307.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'murfreesboro',
    name: 'Murfreesboro',
    countySlug: 'rutherford-county',
    countyName: 'Rutherford County',
    zips: '37127, 37128, 37129, 37130, 37132',
    landmarks: 'Middle Tennessee State University (MTSU), Saint Thomas Rutherford Hospital, Stones River National Battlefield, Cannonsburgh Village',
    nearbyCities: ['smyrna', 'la-vergne', 'nashville'],
    intro:
      "Murfreesboro is one of Tennessee's fastest-growing cities, and India serves it like a local. From MTSU faculty needing apostilles for international research and Fulbright placements, to Stones River-area families closing on new construction, to attorneys filing estate plans on the historic square — India brings the same accuracy and same-day availability she's known for in Nashville.",
    bullets: [
      'MTSU faculty & student apostille service for international study, research, and adoption',
      'Loan signings throughout Murfreesboro and the Stones River corridor',
      'Bedside visits at Saint Thomas Rutherford and NHC HealthCare Murfreesboro',
      'Estate planning home visits and historic-square attorney coordination',
      'Wedding officiant for Cannonsburgh, Stones River venues, and Murfreesboro courthouse',
    ],
    heroImage: 'https://images.pexels.com/photos/4689068/pexels-photo-4689068.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'smyrna',
    name: 'Smyrna',
    countySlug: 'rutherford-county',
    countyName: 'Rutherford County',
    zips: '37167',
    landmarks: 'Nissan Smyrna manufacturing plant, Sam Davis Home, Smyrna/Rutherford County Airport, downtown Smyrna',
    nearbyCities: ['murfreesboro', 'la-vergne', 'nashville'],
    intro:
      "Smyrna's Nissan-anchored economy and growing residential subdivisions keep India busy with loan signings, I-9 verifications for plant employers, and estate planning for long-time Smyrna families. India is a familiar face in Smyrna's title companies and HR offices — and a friendly visitor at family kitchen tables.",
    bullets: [
      'Loan signings throughout Smyrna and the Nissan-corridor neighborhoods',
      'I-9 verifications for Nissan supplier and Smyrna-area employers',
      'Estate planning home visits — trusts, healthcare directives, POAs',
      'Apostille handling for Smyrna families and corporate filings',
      'Wedding officiant for Sam Davis Home and downtown Smyrna venues',
    ],
    heroImage: 'https://images.pexels.com/photos/2833713/pexels-photo-2833713.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'la-vergne',
    name: 'La Vergne',
    countySlug: 'rutherford-county',
    countyName: 'Rutherford County',
    zips: '37086',
    landmarks: 'Hickory Hollow Pkwy industrial corridor, Lake Forest, Old Nashville Highway, Waldron Road',
    nearbyCities: ['smyrna', 'antioch', 'murfreesboro'],
    intro:
      "La Vergne — wedged between Antioch and Smyrna — is a regular stop on India\'s southeast route. New-construction closings, refinance packages, corporate I-9 verifications, and apostille service for relocating families all part of the weekly La Vergne calendar.",
    bullets: stdBullets('La Vergne'),
    heroImage: 'https://images.pexels.com/photos/28412260/pexels-photo-28412260.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'eagleville',
    name: 'Eagleville',
    countySlug: 'rutherford-county',
    countyName: 'Rutherford County',
    zips: '37060',
    landmarks: 'Eagleville City Park, Eagleville Schools, Highway 99 corridor, rolling Rutherford farmland',
    nearbyCities: ['murfreesboro', 'college-grove', 'rockvale'],
    intro:
      "Eagleville — Rutherford County\'s rural western gateway — is a quieter community where India\'s mobile notary work matters most: hospice and estate planning visits to long-time family farms, loan signings for the new families relocating in, and the occasional courthouse-coordinated estate filing.",
    bullets: stdBullets('Eagleville'),
    heroImage: 'https://images.pexels.com/photos/11467701/pexels-photo-11467701.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'mt-juliet',
    name: 'Mt. Juliet',
    countySlug: 'wilson-county',
    countyName: 'Wilson County',
    zips: '37122',
    landmarks: 'Providence Marketplace, Old Hickory Lake (south shore), Charlie Daniels Park, Mt. Juliet Public Library',
    nearbyCities: ['lebanon', 'hermitage', 'nashville'],
    intro:
      "Mt. Juliet's Providence corridor and lakeside neighborhoods generate steady demand for fast, on-time mobile notary service. Refinance packages, estate-planning packets, and apostilles for relocating families are all part of India's weekly Mt. Juliet circuit. She's familiar with every Providence-area title company and can usually be on-site within 60 minutes of your call.",
    bullets: [
      'Loan signings throughout Mt. Juliet and the Providence Marketplace corridor',
      'Estate planning home visits — trusts, healthcare directives, and POAs',
      'Apostille handling for Mt. Juliet families relocating internationally',
      'Bedside visits at Mt. Juliet senior-living communities and TriStar Summit',
      'General mobile notary — affidavits, vehicle titles, parental travel consent',
    ],
    heroImage: 'https://images.pexels.com/photos/17715307/pexels-photo-17715307.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'lebanon',
    name: 'Lebanon',
    countySlug: 'wilson-county',
    countyName: 'Wilson County',
    zips: '37087, 37088, 37090',
    landmarks: 'Cumberland University, Cracker Barrel headquarters, Cedars of Lebanon State Park, downtown Lebanon historic square',
    nearbyCities: ['mt-juliet', 'watertown', 'nashville'],
    intro:
      "Lebanon — the Wilson County seat — combines historic-square charm with a growing corporate base anchored by Cracker Barrel headquarters and Cumberland University. India serves Lebanon attorneys, business owners, and families with the same prompt, accurate mobile notary work she delivers in downtown Nashville.",
    bullets: [
      'Loan signings throughout Lebanon and surrounding Wilson County',
      'Cracker Barrel and Cumberland University corporate I-9 / apostille support',
      'Estate planning home visits and historic-square attorney coordination',
      'Bedside notary visits at TriStar Summit and area senior-living communities',
      'Wedding officiant for downtown Lebanon square and Cedars of Lebanon venues',
    ],
    heroImage: 'https://images.pexels.com/photos/11467701/pexels-photo-11467701.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'watertown',
    name: 'Watertown',
    countySlug: 'wilson-county',
    countyName: 'Wilson County',
    zips: '37184',
    landmarks: 'Historic Watertown Square, Tennessee Central Railway Museum stop, Round Lick Creek, Watertown School',
    nearbyCities: ['lebanon', 'mt-juliet', 'gordonsville'],
    intro:
      "Watertown — a charming Wilson County small town anchored by its historic square — is a regular stop for India\'s estate planning visits, loan signings, and the occasional small-town courthouse-coordinated filing. The 35-minute drive from Nashville is part of why India serves Watertown faithfully.",
    bullets: stdBullets('Watertown'),
    heroImage: 'https://images.pexels.com/photos/2898211/pexels-photo-2898211.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'spring-hill',
    name: 'Spring Hill',
    countySlug: 'maury-county',
    countyName: 'Maury County (also Williamson County)',
    zips: '37174',
    landmarks: 'GM Spring Hill Manufacturing Plant, Crossings of Spring Hill, Saturn Parkway corridor, Port Royal State Park',
    nearbyCities: ['franklin', 'columbia', 'thompson-station'],
    intro:
      "Spring Hill is one of Tennessee's fastest-growing cities — split between Maury and Williamson counties, anchored by the GM plant, and adding new neighborhoods every month. India's Spring Hill calendar is filled with refinance closings, new-construction signings, GM-supplier I-9 verifications, and young-family estate planning packages.",
    bullets: [
      'New-construction and refinance loan signings throughout Spring Hill',
      'GM-supplier I-9 verifications and corporate apostille support',
      'Estate planning home visits for young Spring Hill families',
      'Bedside notary visits at Maury Regional Medical Center',
      'Apostille service and Tennessee Secretary of State filing',
    ],
    heroImage: 'https://images.pexels.com/photos/2898211/pexels-photo-2898211.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'columbia',
    name: 'Columbia',
    countySlug: 'maury-county',
    countyName: 'Maury County',
    zips: '38401',
    landmarks: 'James K. Polk Home, Maury Regional Medical Center, downtown Columbia historic district, Mule Town Square',
    nearbyCities: ['spring-hill', 'mount-pleasant', 'culleoka'],
    intro:
      "Columbia — the Maury County seat — combines historic-district charm with a growing residential base. India is a familiar face at the courthouse, Maury Regional Medical Center, and the downtown attorneys\' offices around Mule Town Square. Estate planning, apostille, loan signings, and wedding officiant ceremonies all part of her regular Columbia schedule.",
    bullets: stdBullets('Columbia'),
    heroImage: 'https://images.pexels.com/photos/11467701/pexels-photo-11467701.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
  {
    slug: 'mount-pleasant',
    name: 'Mount Pleasant',
    countySlug: 'maury-county',
    countyName: 'Maury County',
    zips: '38474',
    landmarks: 'Mount Pleasant Square, Carter House Historic Site, Highway 43 corridor, Mount Pleasant Schools',
    nearbyCities: ['columbia', 'culleoka', 'spring-hill'],
    intro:
      "Mount Pleasant — Maury County\'s historic phosphate-mining town — is a quieter community where India\'s services matter most: hospice and estate planning visits to long-time families, loan signings for relocating buyers, and small-town courthouse coordination.",
    bullets: stdBullets('Mount Pleasant'),
    heroImage: 'https://images.pexels.com/photos/17715307/pexels-photo-17715307.jpeg?auto=compress&cs=tinysrgb&w=1920',
  },
];

export const findCounty = (slug) => COUNTIES.find((c) => c.slug === slug);
export const findCity = (slug) => CITIES.find((c) => c.slug === slug);

// Returns child cities for a county. A city may belong to multiple counties (e.g. Spring Hill
// straddles Maury + Williamson) — we include any city whose own countySlug matches OR whose slug
// is listed in the county's own .cities[] declaration.
export const citiesInCounty = (countySlug) => {
  const county = findCounty(countySlug);
  const declared = county ? county.cities || [] : [];
  const seen = new Set();
  const result = [];
  for (const slug of declared) {
    const c = findCity(slug);
    if (c && !seen.has(c.slug)) {
      seen.add(c.slug);
      result.push(c);
    }
  }
  for (const c of CITIES) {
    if (c.countySlug === countySlug && !seen.has(c.slug)) {
      seen.add(c.slug);
      result.push(c);
    }
  }
  return result;
};
